export const doc = {
    docType: "What is indiv's immigration document type?",
    registrationNumber: 'Alien Number',
    i94: 'I-94 Number',
    visa: 'Visa Number',
    passport: 'Passport Number',
    countryIssuance: 'Country of Issuance',
    cardNumber: 'Receipt/Card Number',
    expDate: 'Document/Passport Expiration Date',
    documentDescription: 'Document Description',
    naturalizationCertificateNumber: 'Naturalization Certificate Number',
    certificateOfCitizenshipNumber: 'Certificate of Citizenship',
    sevisID: 'SEVIS ID'
}
export const immigration = {
    statusGainDate: 'IMMIGRATION_STATIC_TEXT21',
    status: "What is indiv's immigration status?",
    currentImmigrationStatus: "IMMIGRATION_STATIC_TEXT41",
    document: doc
}

export const military = {
    isVeteranOrActiveDuty: 'Is indiv veteran or active duty member?',
    isSpouseVeteranOrActiveDuty: "Is indiv's spouse a veteran or active duty member?",
    isParentVeteranOrActiveDuty: 'Is the parent of the indiv in the household a veteran or active duty member?'
}

export default {
    eligibleImmigration: "IMMIGRATION_STATIC_TEXT42",
    immigration: immigration,
    militaryInfo: military
}